import { AddressInfo } from 'models/AddressInfo';
import { AddressField } from './index';

type AddressFields = { [P in keyof Required<AddressInfo>]: { input: { value: string } } };

export const RenderAddress = (reset: () => void) => (props: AddressFields) => {
  const fields = {
    identityNumber: props.identityNumber.input.value,
    firstName: props.firstName.input.value,
    lastName: props.lastName.input.value,
    street: props.street.input.value,
    city: props.city.input.value,
    zipCode: props.zipCode.input.value
  };

  return <AddressField reset={reset} {...fields} />;
};
